import gql from 'graphql-tag'

export const fetchComercialCategory = () => {
	return {
		query: gql`
			{
				comercial_category {
					id
					category
				}
			}
		`,
		update(data) {
			return data.comercial_category
		}
	}
}
